/**
 * @generated SignedSource<<a32b5089c2d72ba5f395180cb4cb50b5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LimitPeriodType = "MINUTES" | "SESSION";
export type ToolUsageType = "AIStudio" | "CustomizerAIImageGenerator" | "CustomizerDesignGenerator" | "CustomizerProductStaging" | "CustomizerVirtualTryOn";
export type usageControlsQuery$variables = {
  toolType: ToolUsageType;
};
export type usageControlsQuery$data = {
  readonly toolUsageRuleByToolType: {
    readonly allowLoggedUsers: boolean;
    readonly allowNonLoggedUsers: boolean;
    readonly applyToAllTools: boolean;
    readonly limitEnabled: boolean;
    readonly limitPeriodMinutes: number | null;
    readonly limitPeriodType: LimitPeriodType | null;
    readonly maxOperations: number | null;
    readonly toolUsageRuleID: number;
  } | null;
};
export type usageControlsQuery = {
  response: usageControlsQuery$data;
  variables: usageControlsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "toolType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "toolType",
    "variableName": "toolType"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "toolUsageRuleID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "applyToAllTools",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowLoggedUsers",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowNonLoggedUsers",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limitEnabled",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limitPeriodType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "maxOperations",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "limitPeriodMinutes",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usageControlsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ToolUsageRuleInfo",
        "kind": "LinkedField",
        "name": "toolUsageRuleByToolType",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "usageControlsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ToolUsageRuleInfo",
        "kind": "LinkedField",
        "name": "toolUsageRuleByToolType",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "25bf8be177660455f1306d1b09e58984",
    "id": null,
    "metadata": {},
    "name": "usageControlsQuery",
    "operationKind": "query",
    "text": "query usageControlsQuery(\n  $toolType: ToolUsageType!\n) {\n  toolUsageRuleByToolType(toolType: $toolType) {\n    toolUsageRuleID\n    applyToAllTools\n    allowLoggedUsers\n    allowNonLoggedUsers\n    limitEnabled\n    limitPeriodType\n    maxOperations\n    limitPeriodMinutes\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "847c9c06c0b44834d060fb7b8458dfc5";

export default node;
